import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import {
	HookFormDatePickerCommon,
	HookFormInputGroup,
	HookFormPhoneInput,
} from "components";
import { trimMidSentenceNormalizer, trimNormalizer } from "validators";
import {
	maxLength100,
	maxLength20,
	maxLength50,
	minLength2,
	normalizeAll,
	onlyAlphanumericAndDashNormalizer,
	onlyAlphanumericAndSpecialCharacters,
	required,
} from "validators/validation";

type ShippingDetailsProps = {
	sectionName: string;
	isLoading: boolean;
	isApplication?: boolean;
};

const ShippingDetails = ({
	sectionName,
	isLoading,
	isApplication = false,
}: ShippingDetailsProps) => {
	const {
		register,

		formState: { errors },
	} = useFormContext();

	return (
		<>
			<Row>
				<Col md={5}>
					<HookFormPhoneInput
						name={`${sectionName}.phoneNumber`}
						label="Phone"
						isLoading={isLoading}
						isRequired
					/>
				</Col>
				{!isApplication && (
					<Col md={{ span: 5, offset: 2 }}>
						<HookFormInputGroup
							name={`${sectionName}.orderNumber`}
							register={register}
							label="Order Number"
							colInput={6}
							colLabel={6}
							blurLoading={isLoading}
							autoComplete="off"
							validator={{ maxLength50, required }}
							normalize={onlyAlphanumericAndSpecialCharacters}
							normalizeOnBlur={trimNormalizer}
							errors={errors}
							showRequiredMark
						/>
					</Col>
				)}
			</Row>

			{!isApplication && (
				<>
					<Row data-autotest="shippingDetails">
						<Col md={5}>
							<HookFormInputGroup
								name={`${sectionName}.vendor`}
								register={register}
								label="Vendor"
								colInput={6}
								colLabel={6}
								blurLoading={isLoading}
								autoComplete="off"
								errors={errors}
								validator={{
									minLength2,
									maxLength100,
									required,
								}}
								normalize={normalizeAll([
									onlyAlphanumericAndSpecialCharacters,
									trimMidSentenceNormalizer,
								])}
								normalizeOnBlur={trimNormalizer}
								showRequiredMark
							/>
						</Col>
						<Col md={{ span: 5, offset: 2 }}>
							<HookFormDatePickerCommon
								label="Date Ordered"
								name={`${sectionName}.orderedAt`}
								isLoading={isLoading}
								maxDate={new Date()}
								showRequiredMark
								rules={{
									validate: {
										required,
									},
								}}
							/>
						</Col>
					</Row>
					<Row>
						<Col md={5}>
							<HookFormInputGroup
								name={`${sectionName}.carrier`}
								register={register}
								label="Carrier"
								colInput={6}
								colLabel={6}
								blurLoading={isLoading}
								autoComplete="off"
								normalizeOnBlur={trimNormalizer}
								errors={errors}
								validator={{ maxLength50, required }}
								showRequiredMark
							/>
						</Col>
						<Col md={{ span: 5, offset: 2 }}>
							<HookFormInputGroup
								name={`${sectionName}.trackingNumber`}
								register={register}
								label="Tracking Number"
								colInput={6}
								colLabel={6}
								blurLoading={isLoading}
								autoComplete="off"
								normalize={onlyAlphanumericAndDashNormalizer}
								validator={{
									minLength2,
									maxLength20,
								}}
								normalizeOnBlur={trimNormalizer}
								errors={errors}
							/>
						</Col>
					</Row>
					<Row>
						<Col md={5}>
							<HookFormDatePickerCommon
								label="Date Shipped"
								name={`${sectionName}.shippedAt`}
								isLoading={isLoading}
								maxDate={new Date()}
							/>
						</Col>
						<Col md={{ span: 5, offset: 2 }}>
							<HookFormDatePickerCommon
								label="Date Delivered"
								name={`${sectionName}.deliveredAt`}
								isLoading={isLoading}
								maxDate={new Date()}
							/>
						</Col>
					</Row>
				</>
			)}
		</>
	);
};

export default ShippingDetails;
